<!-- eslint-disable max-len -->
<template>
  <svg viewBox="0 0 959.64 230.39">
    <defs>
      <linearGradient
        id="circle"
        x1="173.17"
        y1="86.95"
        x2="141.86"
        y2="141.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stop-color="#cc9300"
        />
        <stop
          offset=".47"
          stop-color="#ea433a"
        />
        <stop
          offset="1"
          stop-color="#b327bf"
        />
      </linearGradient>
      <linearGradient
        id="square"
        x1="92.49"
        y1="41"
        x2="67.07"
        y2="110.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stop-color="#cc9300"
        />
        <stop
          offset=".26"
          stop-color="#ea433a"
        />
        <stop
          offset=".47"
          stop-color="#b327bf"
        />
        <stop
          offset=".76"
          stop-color="#66f"
        />
        <stop
          offset="1"
          stop-color="#00bf9a"
        />
      </linearGradient>
      <linearGradient
        id="triangle"
        x1="75.13"
        y1="190.31"
        x2="120.2"
        y2="143.64"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stop-color="#b327bf"
        />
        <stop
          offset=".47"
          stop-color="#66f"
        />
        <stop
          offset="1"
          stop-color="#00c09a"
        />
      </linearGradient>
    </defs>
    <path
      fill="#ffffff"
      d="M290.25 154.82h-14.78l33.21-92.29h16.09L358 154.82h-14.8l-8.43-24.42h-36zm12.53-36.14h27.94l-13.61-39.39h-.72zM369.18 180.78V85.6h13.16v11.22h1.13a42.54 42.54 0 013.4-5 19.13 19.13 0 016.13-5q3.94-2.15 10.34-2.14a26.87 26.87 0 0114.94 4.24 28.72 28.72 0 0110.34 12.21q3.78 8 3.79 19.2t-3.74 19.22a28.8 28.8 0 01-10.28 12.32 26.55 26.55 0 01-14.92 4.28 21.77 21.77 0 01-10.27-2.11 19.92 19.92 0 01-6.24-5 36.14 36.14 0 01-3.49-5h-.82v36.73zm13.2-60.57q0 10.91 4.69 17.69t13.39 6.78a15.79 15.79 0 0010.11-3.22 19.62 19.62 0 006.15-8.76 35.3 35.3 0 002.08-12.49 34.86 34.86 0 00-2.05-12.32 19.2 19.2 0 00-6.11-8.59 16.1 16.1 0 00-10.18-3.15q-8.83 0-13.46 6.6t-4.62 17.46zM475.65 156.22a31.8 31.8 0 01-17-4.46 30 30 0 01-11.27-12.51 41.48 41.48 0 01-4-18.72 41.89 41.89 0 014-18.84 30 30 0 0111.27-12.53 34.63 34.63 0 0134 0 30.08 30.08 0 0111.24 12.53 41.75 41.75 0 014 18.84 41.35 41.35 0 01-4 18.72 30.09 30.09 0 01-11.24 12.51 31.77 31.77 0 01-17 4.46zm0-11.31a16.09 16.09 0 0010.48-3.34 19.76 19.76 0 006.13-8.9 38.21 38.21 0 000-24.4 19.92 19.92 0 00-6.13-9 18.1 18.1 0 00-21 0 20 20 0 00-6.17 9 37.68 37.68 0 000 24.4 19.83 19.83 0 006.17 8.9 16.17 16.17 0 0010.56 3.34zM571.36 102.5l-12.21 2.16a15.24 15.24 0 00-4.35-6.37q-3.18-2.91-9.48-2.91a17 17 0 00-9.58 2.55 7.49 7.49 0 00-3.81 6.55 6.7 6.7 0 002.55 5.61c1.72 1.4 4.5 2.55 8.31 3.45l11 2.53q18.93 4.37 18.93 18.74a18.11 18.11 0 01-3.59 11.09 23.84 23.84 0 01-10 7.57 37 37 0 01-14.76 2.75q-11.67 0-19-5a21.06 21.06 0 01-9-14.17l13-2q2.43 10.28 14.87 10.28 6.63 0 10.59-2.77t4-6.79q0-6.62-9.78-8.78l-11.72-2.57q-9.74-2.16-14.33-7a17.12 17.12 0 01-4.59-12.21 17.57 17.57 0 013.42-10.75 22.33 22.33 0 019.46-7.19 35.14 35.14 0 0113.84-2.57q11.22 0 17.67 4.87a22.82 22.82 0 018.56 12.93zM618.79 85.6v10.82H604.6v38.08q0 5.85 2.5 7.55a10.16 10.16 0 005.79 1.69 15.76 15.76 0 002.84-.23l1.89-.36 2.43 11.13a24.72 24.72 0 01-3.35.93 28.34 28.34 0 01-5.39.51 23.94 23.94 0 01-9.94-1.89 16.78 16.78 0 01-7.43-6.13 18.08 18.08 0 01-2.82-10.41V96.42H581V85.6h10.14V69h13.46v16.6zM632.65 154.82V85.6h13v11h.72a16.88 16.88 0 016.69-8.81A19.1 19.1 0 01664 84.56c.87 0 1.88 0 3 .09s2 .14 2.7.23v12.89a27.1 27.1 0 00-2.86-.52 30.32 30.32 0 00-4.17-.29 16.62 16.62 0 00-11.85 4.39 14.66 14.66 0 00-4.69 11.2v42.27zM706.38 156.22a31.82 31.82 0 01-17-4.46 30.09 30.09 0 01-11.27-12.51 41.48 41.48 0 01-4-18.72 41.89 41.89 0 014-18.84 30.08 30.08 0 0111.27-12.53 34.63 34.63 0 0134 0 30.08 30.08 0 0111.24 12.53 41.75 41.75 0 014 18.84 41.35 41.35 0 01-4 18.72 30.09 30.09 0 01-11.24 12.51 31.77 31.77 0 01-17 4.46zm0-11.31a16.09 16.09 0 0010.48-3.34 19.76 19.76 0 006.13-8.9 38 38 0 000-24.4 19.92 19.92 0 00-6.13-9 18.1 18.1 0 00-21 0 20 20 0 00-6.17 9 37.68 37.68 0 000 24.4 19.83 19.83 0 006.17 8.9 16.21 16.21 0 0010.56 3.34zM750.86 180.78V85.6H764v11.22h1.13a42.54 42.54 0 013.4-5 19 19 0 016.13-5q3.97-2.12 10.34-2.12a26.87 26.87 0 0115 4.24 28.72 28.72 0 0110.34 12.21q3.8 8 3.79 19.2t-3.74 19.22a28.8 28.8 0 01-10.28 12.32 26.56 26.56 0 01-14.91 4.28 21.78 21.78 0 01-10.28-2.11 20 20 0 01-6.24-5 36.14 36.14 0 01-3.49-5h-.82v36.73zm13.2-60.57q0 10.91 4.69 17.69t13.39 6.78a15.79 15.79 0 0010.11-3.22 19.62 19.62 0 006.15-8.76 35.3 35.3 0 002.08-12.49 34.86 34.86 0 00-2.05-12.32 19.2 19.2 0 00-6.11-8.59 16.1 16.1 0 00-10.18-3.15q-8.83 0-13.46 6.6t-4.62 17.46zM840.12 113.72v41.1h-13.47V62.53h13.29v34.34h.86a19.7 19.7 0 017.43-8.9q5-3.27 13.07-3.27 10.68 0 17.19 6.58t6.51 19.51v44h-13.47v-42.4q0-7.62-3.92-11.83t-10.91-4.19a16.41 16.41 0 00-11.89 4.53q-4.69 4.53-4.69 12.82zM930 156.22a33.6 33.6 0 01-17.58-4.42A29.35 29.35 0 01901 139.39a41.51 41.51 0 01-4-18.73 41.91 41.91 0 014-18.74 29.83 29.83 0 0128-17.22 33 33 0 0114.85 3.49 27.09 27.09 0 0111.4 11.13q4.39 7.65 4.39 20.17v4.78h-49.21q.27 10 5.64 15.41t14 5.41a19.22 19.22 0 0010-2.48 13.85 13.85 0 006-7.39l12.75 2.3a23.37 23.37 0 01-9.92 13.56q-7.64 5.14-18.9 5.14zm-19.47-42h36a18.91 18.91 0 00-4.87-13.22q-4.73-5.21-12.57-5.21a17.59 17.59 0 00-9.53 2.55 18.68 18.68 0 00-6.45 6.71 20.52 20.52 0 00-2.63 9.12z"
    />
    <path
      d="M154.49 220.39l-44.16 7c-30.12 4.77-41.53 3.36-53.48-.78a62.25 62.25 0 01-29.59-21.5C19.63 195 14.77 184.61 10 154.49l-7-44.16c-4.77-30.12-3.36-41.53.78-53.48a62.25 62.25 0 0121.5-29.59C35.36 19.63 45.78 14.77 75.9 10l44.16-7c30.12-4.77 41.53-3.36 53.48.78a62.18 62.18 0 0129.58 21.5c7.64 10.08 12.5 20.5 17.27 50.62l7 44.16c4.77 30.12 3.36 41.53-.78 53.48a62.18 62.18 0 01-21.5 29.58c-10.11 7.64-20.5 12.5-50.62 17.27z"
    />
    <path
      d="M162.43 145.1a31.43 31.43 0 10-35.65-26.17 31.28 31.28 0 0035.65 26.17zm-1.57-9.94a21.37 21.37 0 1117.45-24.39 21.2 21.2 0 01-17.45 24.39z"
      fill="url(#circle)"
    />
    <path
      d="M61 107.94l46.64-7.38a5 5 0 004.18-5.76l-7.4-46.71a5 5 0 00-5.76-4.19L52 51.29a5 5 0 00-4.18 5.76l7.4 46.71a5 5 0 005.78 4.18zm3.39-10.72l-5.87-36.77 36.7-5.81L101 91.41z"
      fill="url(#square)"
    />
    <path
      d="M90.56 124.91l-20.23 56.65a5 5 0 005.53 6.67l56.94-9a5 5 0 003.2-8.05l-36.71-47.65a5 5 0 00-8.73 1.38zM96.94 137l25.91 33.62L82.66 177z"
      fill="url(#triangle)"
    />
  </svg>
</template>
